import VocHeaderMenuNew from "./src/header-menu"

/* istanbul ignore next */
VocHeaderMenuNew.install = function (Vue) {
  Vue.component(VocHeaderMenuNew.name, VocHeaderMenuNew)
}

export default VocHeaderMenuNew
